import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [{
      path: '/app-home',
      name: '应用首页',
      component: () => import('../views/AppHome.vue'),
    },
    {
      path: '/app-info',
      name: '应用详情',
      component: () => import('../views/AppInfo.vue'),
    }
  ],
});
